import * as React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';

import { useSecurityJourneyTranslations } from '../../locales/use-security-journey-translations';

import { FrameworkOverviewAccordionItem } from './framework-overview-accordion-item';

type FrameworkOverviewAccordionProps = {
  elements: string[];
  framework: string;
  numberedList?: boolean;
  totalGroups: number;
  totalFrameworks: number;
  bpId: string;
};

export const FrameworkOverviewAccordion: React.FC<
  FrameworkOverviewAccordionProps
> = ({
  framework,
  elements,
  numberedList,
  bpId,
  totalGroups,
  totalFrameworks = 0,
}) => {
  const { t } = useSecurityJourneyTranslations();

  return (
    <Accordion defaultExpanded={elements.length > 0}>
      <AccordionSummary
        aria-controls={`${bpId}-${t(`spidrID.spidrDetails.${framework}`)}-content`}
        id={`${bpId}-${t(`spidrID.spidrDetails.${framework}`)}-header`}
      >
        <Stack direction="row" gap={1}>
          <Typography component="span">
            {t(`spidrID.spidrDetails.${framework}`)}
          </Typography>
          <Typography color="textSecondary" component="span">
            {`${totalFrameworks}/${totalGroups} ${t(`spidrLibrary.coverage.${framework}.groups`)}`}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        {elements.map((element, index) => {
          return (
            <FrameworkOverviewAccordionItem
              key={`${index}-${element}`}
              label={element}
              number={numberedList ? index + 1 : undefined}
            />
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};
